import { render, staticRenderFns } from "./PerfilGeral.vue?vue&type=template&id=7ff499ac"
import script from "./PerfilGeral.vue?vue&type=script&lang=js"
export * from "./PerfilGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports